import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from "react-router-dom";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";


const DbnNetwork = () => {
    const navigate = useNavigate();
    const image1 = require("../../assets/img/cash.png");
    const image2 = require("../../assets/img/default community.jpg");

    const handleSupport = async () => {
        await navigate('customer/support')
    }

    const DbnNetworkContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'DBN_NETWORK_CONTENT') : null;
    const DbnNetworkImpactSection: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'DBN_NETWORK_IMPACT_SECTION') : null;
    const DbnNetworkWhoSection: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'DBN_NETWORK_WHO_IS_IT_SECTION') : null;



    return (
        <>
            {/* Section: Fueling Dreams, Creating Impact */}
            <div className="bg-white py-20 px-8 flex flex-col md:flex-row items-center justify-between">
                {/* Left Image */}
                <div className="w-full md:w-1/2 mb-8 md:mb-0 flex justify-center">
                    <img
                        src={DbnNetworkContent && DbnNetworkContent[0]?.src
                            ? DbnNetworkContent[0].src
                            : image2}
                        alt="Handshake"
                        className="rounded-md w-full max-w-md object-cover shadow-lg"
                    />
                </div>

                {/* Right Text Content */}
                <div className="w-full md:w-1/2 md:pl-12">
                    <h2 className="text-4xl font-bold mb-4 leading-tight">
                        {DbnNetworkContent && DbnNetworkContent[0]?.title ? (
                            (() => {
                                const titleWords = DbnNetworkContent[0].title.split(' ');
                                const middle = Math.floor(titleWords.length / 2);
                                const firstHalf = titleWords.slice(0, middle).join(' ');
                                const secondHalf = titleWords.slice(middle).join(' ');
                                return (
                                    <>
                                        <span className="text-primary">{firstHalf} </span>
                                        <span className="text-black">{secondHalf}</span>
                                    </>
                                );
                            })()
                        ) : (
                            <>
                                <span className="text-orange-600">Fueling Dreams, </span>
                                <span className="text-black">Creating Impact</span>
                            </>
                        )}
                        {/* <span className="text-primary">Fueling Dreams, </span>
      <span className="text-black">Creating Impact</span> */}
                    </h2>
                    <p className="text-gray-700 text-lg mb-6">
                        {DbnNetworkContent && DbnNetworkContent[0]?.subTitle
                            ? DbnNetworkContent[0].subTitle
                            : "Your support empowers thousands of entrepreneurs, enabling them to build businesses that drive economic growth and social change."}
                        {/* Your support empowers thousands of entrepreneurs, enabling them to build businesses that drive economic growth and social change. */}
                    </p>
                    <button className="bg-primary text-white px-6 py-3 rounded-md hover:bg-primary-dark transition">
                        {DbnNetworkContent && DbnNetworkContent[0]?.description
                            ? DbnNetworkContent[0].description
                            : "DBN Network"}
                    </button>
                </div>
            </div>

            {/* Section: How Your Contribution impacts Entrepreneurship */}
            <div className="bg-orange-50 py-20 px-8 text-center">
                <h2 className="text-3xl md:text-4xl font-bold mb-12">
                    {DbnNetworkImpactSection && DbnNetworkImpactSection[0]?.title ? (
                        (() => {
                            const titleWords = DbnNetworkImpactSection[0].title.split(' ');
                            const middle = Math.floor(titleWords.length / 2);
                            const firstHalf = titleWords.slice(0, middle).join(' ');
                            const secondHalf = titleWords.slice(middle).join(' ');
                            return (
                                <>
                                    <span className="text-primary">{firstHalf} </span>
                                    <span className="text-black">{secondHalf}</span>
                                </>
                            );
                        })()
                    ) : (
                        <>
                            <span className="text-orange-600">DBN Network </span>
                            <span className="text-black">brings together mentors</span>
                        </>
                    )}
                    {/* <span className="text-primary">DBN Network </span> brings together mentors */}
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {/* Social Impact */}
                    <div className="border border-secondary rounded-lg p-6 bg-white hover:shadow-md transition">
                        <div className="text-4xl mb-4 text-primary-500"></div>
                        <h3 className="text-xl font-semibold mb-2">
                            {DbnNetworkImpactSection && DbnNetworkImpactSection[0]?.subTitle
                                ? DbnNetworkImpactSection[0].subTitle
                                : "Connecting Catalysts"}
                            {/* Connecting Catalysts */}
                        </h3>
                        <p className="text-gray-700 text-sm">
                            {DbnNetworkImpactSection && DbnNetworkImpactSection[0]?.description
                                ? DbnNetworkImpactSection[0].description
                                : "Connecting Catalysts for India's Digital Future"}
                            {/* Connecting Catalysts for India's Digital Future */}
                        </p>
                    </div>

                    {/* Ecosystem Expansion */}
                    <div className="border border-secondary rounded-lg p-6 bg-white hover:shadow-md transition">
                        <div className="text-4xl mb-4 text-primary"></div>
                        <h3 className="text-xl font-semibold mb-2">
                            {DbnNetworkImpactSection && DbnNetworkImpactSection[1]?.subTitle
                                ? DbnNetworkImpactSection[1].subTitle
                                : "Ecosystem Expansion"}
                            {/* Ecosystem Expansion */}
                        </h3>
                        <p className="text-gray-700 text-sm">
                            {DbnNetworkImpactSection && DbnNetworkImpactSection[1]?.description
                                ? DbnNetworkImpactSection[1].description
                                : "Powering Entrepreneurs Through Collaboration"}
                            {/* Powering Entrepreneurs Through Collaboration */}
                        </p>
                    </div>

                    {/* Startup Support */}
                    <div className="border border-secondary rounded-lg p-6 bg-white hover:shadow-md transition">
                        <div className="text-4xl mb-4 text-primary"></div>
                        <h3 className="text-xl font-semibold mb-2">
                            {DbnNetworkImpactSection && DbnNetworkImpactSection[2]?.subTitle
                                ? DbnNetworkImpactSection[2].subTitle
                                : "Startup Support"}
                            {/* Startup Support */}
                        </h3>
                        <p className="text-gray-700 text-sm">
                            {DbnNetworkImpactSection && DbnNetworkImpactSection[2]?.description
                                ? DbnNetworkImpactSection[2].description
                                : "Fueling Startups with Knowledge, Network, and Support."}
                            {/* Fueling Startups with Knowledge, Network, and Support. */}
                        </p>
                    </div>
                </div>


                {/* Section: Who is it for? */}
                <div className="bg-white py-20 px-8 text-center mt-5">
                    <h2 className="text-3xl md:text-4xl font-bold mb-12">
                        {DbnNetworkWhoSection && DbnNetworkWhoSection[0]?.title ? (
                            (() => {
                                const titleWords = DbnNetworkWhoSection[0].title.split(' ');
                                const middle = Math.floor(titleWords.length / 2);
                                const firstHalf = titleWords.slice(0, middle).join(' ');
                                const secondHalf = titleWords.slice(middle).join(' ');
                                return (
                                    <>
                                        <span className="text-primary">{firstHalf} </span>
                                        <span className="text-black">{secondHalf}</span>
                                    </>
                                );
                            })()
                        ) : (
                            <>
                                <span className="text-orange-600">Who is it </span>
                                <span className="text-black">for?</span>
                            </>
                        )}
                        {/* Who is it <span className="text-primary">for?</span> */}
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
                        {/* Card 1 */}
                        <div className="flex flex-col items-center text-center ">
                            <img src={DbnNetworkWhoSection && DbnNetworkWhoSection[0]?.src
                                ? DbnNetworkWhoSection[0].src
                                : image1} className="w-16 h-16 mb-4" />
                            <p className="text-gray-700 text-base">
                                {DbnNetworkWhoSection && DbnNetworkWhoSection[0]?.subTitle
                                    ? DbnNetworkWhoSection[0].subTitle
                                    : "Through the DBN Network,  enablers gain access to mentorship opportunities, learning resources, and collaborative programs."}
                                {/* Through the DBN Network,  enablers gain access to mentorship opportunities, learning resources, and collaborative programs. */}
                            </p>
                        </div>

                        {/* Card 2 */}
                        <div className="flex flex-col items-center text-center">
                            <img src={image1} className="w-16 h-16 mb-4" />
                            <p className="text-gray-700 text-base">
                                {DbnNetworkWhoSection && DbnNetworkWhoSection[1]?.subTitle
                                    ? DbnNetworkWhoSection[1].subTitle
                                    : "From training initiatives to startup acceleration, DBN fuels meaningful collaborations for scalable impact"}
                                {/* From training initiatives to startup acceleration, DBN fuels meaningful collaborations for scalable impact */}
                            </p>
                        </div>
                    </div>
                </div>

            </div>






        </>
    );
};

export default DbnNetwork;
